import React from "react";
import config from "../../config/environment.js";

// Export entity configuration for use in routes
export const inspectorEntity = {
  title: "Verificadores",
  friendlyPath: "inspectores",
  path: config.entities.inspector,
  columns: [
    {
      dataField: "id",
      text: "Id Validador",
      isForTable: true,
      inputType: "text",
      errorMessage: "El campo requiere al menos un caracter",
      isForCreate: false,
      isForModify: false,
      required: true,
    },
    {
      dataField: "dni",
      text: "DNI",
      filterLabel: "Buscar por inspector",
      placeholder: "Buscar inspector...",
      isForTable: true,
      requestName: "dni",
      inputType: "number",
      filterInputType: "inspector-autocomplete",
      errorMessage: "Ingrese un DNI válido.",
      hasError: true,
      isBlank: true,
      isFilter: true,
      isForCreate: true,
      isForModify: false,
      min: 1,
      max: 99999999,
      value: undefined,
    },
    {
      dataField: "fullname",
      text: "Nombre",
      isForTable: true,
      inputType: "text",
      errorMessage: "Ingrese un nombre valido",
      isForCreate: false,
      isForModify: false,
    },
    {
      dataField: "gender",
      text: "Género",
      isForTable: true,
      requestName: "gender",
      inputType: "dropdown",
      detailedText: "Género (como figura en el DNI)",
      errorMessage: "Seleccione el género como figura en su DNI.",
      ref: React.createRef(),
      hasError: true,
      isBlank: true,
      isFilter: false,
      isForCreate: true,
      isForModify: false,
      dropdownPath: config.dropdowns.genders,
      formatter: function (cell, row, rowIndex, formatExtraData) {
        return row.genderDescription;
      },
    },
    {
      dataField: "enabled",
      text: "Habilitado",
      isForTable: true,
      requestName: "enabled",
      inputType: "checkbox",
      errorMessage: "Tilde según corresponda.",
      isForCreate: true,
      isForModify: false,
      defaultValue: true,
    },
    {
      dataField: "lineId",
      text: "Linea",
      requestName: "permitAtLines",
      inputType: "dropdown",
      errorMessage: "Seleccione al menos una linea.",
      ref: React.createRef(),
      isFilter: false,
      isMulti: true,
      isForCreate: true,
      isForModify: true,
      dropdownPath: config.dropdowns.lines,
      value: [],
      formatter: function (cell, row, rowIndex, formatExtraData) {
        return row.lineDescription;
      },
    },
    {
      dataField: "companyId",
      text: "Empresa",
      isForTable: true,
      requestName: "permitAtCompanies",
      inputType: "dropdown",
      errorMessage: "Seleccione al menos una empresa.",
      ref: React.createRef(),
      isFilter: false,
      isMulti: true,
      isForCreate: true,
      isForModify: true,
      dropdownPath: config.dropdowns.companies,
      value: [],
      formatter: function (cell, row, rowIndex, formatExtraData) {
        return row.companyDescription;
      },
    },
    {
      dataField: "provinceId",
      text: "Provincia",
      requestName: "permitAtProvinces",
      inputType: "dropdown",
      errorMessage: "Seleccione al menos una provincia.",
      ref: React.createRef(),
      isFilter: false,
      isMulti: true,
      isForCreate: true,
      isForModify: true,
      dropdownPath: config.dropdowns.provinces,
      value: [],
      formatter: function (cell, row, rowIndex, formatExtraData) {
        return row.lineDescription;
      },
    },
    {
      dataField: "municipalityId",
      text: "Municipalidad",
      requestName: "permitAtMunicipalities",
      inputType: "dropdown",
      errorMessage: "Seleccione al menos una municipalidad.",
      ref: React.createRef(),
      isFilter: false,
      isMulti: true,
      isForCreate: true,
      isForModify: true,
      dropdownPath: config.dropdowns.municipalities,
      value: [],
      formatter: function (cell, row, rowIndex, formatExtraData) {
        return row.lineDescription;
      },
    },
    {
      dataField: "jurisdictionId",
      text: "Jurisdicción",
      requestName: "permitAtJurisdictions",
      inputType: "dropdown",
      errorMessage: "Seleccione al menos una jurisdicción.",
      ref: React.createRef(),
      isFilter: false,
      isMulti: true,
      isForCreate: true,
      isForModify: true,
      dropdownPath: config.dropdowns.jurisdictions,
      value: [],
      formatter: function (cell, row, rowIndex, formatExtraData) {
        return row.lineDescription;
      },
    },
  ],
};
